import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook personalizado para gestión de notificaciones de leads
 * @returns {Object} Funciones para gestión de notificaciones
 */
export const useLeadNotifications = () => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    /**
     * Crea un objeto de acción para notificaciones
     * @param {number} TypeAction - Tipo de acción
     * @param {string} vURL - URL de la acción
     * @param {number} idModalType - Tipo de modal
     * @param {number} idLead - ID del lead
     * @returns {string} JSON string del objeto de acción
     */
    const crearObjAction = (TypeAction, vURL, idModalType, idLead) => {
        const objToAction = {
            TypeAction: TypeAction,
            detalles: {
                vUrl: vURL,
                idModalType: idModalType,
                data: {
                    idLead: idLead
                }
            }
        };

        return JSON.stringify(objToAction);
    };

    /**
     * Guarda una notificación en el sistema
     * @param {string} vTitulo - Título de la notificación
     * @param {string} vCuerpo - Cuerpo de la notificación
     * @param {number} idUsuarioTarget - ID del usuario destino
     * @param {string} objToAction - Objeto de acción serializado
     * @param {number} idTipoNotificacion - Tipo de notificación
     * @param {Object} jsonData - Datos adicionales en JSON
     */
    const guardarNotificacion = async (vTitulo, vCuerpo, idUsuarioTarget, objToAction, idTipoNotificacion, jsonData = null) => {
        const jDataSend = {
            vTitulo,
            vCuerpo,
            idUsuarioTarget,
            objToAction,
            idTipoNotificacion,
            jsonData
        };

        const response = await fetch("/api/leads/guardarNotificacion/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                const detalles = JSON.parse(data.detalles);
                const notificacionesList = detalles.table2;

                notificacionesList.forEach((objNotify) => {
                    sendPushNotificationRealTime(objNotify.vToken, objNotify.vCuerpo);
                });
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
        }
    };

    /**
     * Envía notificación push en tiempo real
     * @param {string} vToken - Token FCM del dispositivo
     * @param {string} vNotificacion - Contenido de la notificación
     */
    const sendPushNotificationRealTime = async (vToken, vNotificacion) => {
        const responseTokenFCM = await fetch("/api/account/generateToken/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            console.log('Hubo un problema con la peticion Fetch del token:' + error);
        });

        if (responseTokenFCM.ok) {
            const dataFCM = await responseTokenFCM.json();
            const tokenFCM = dataFCM.detalles;

            try {
                const response = await fetch('https://fcm.googleapis.com/v1/projects/akasia-admin-panel/messages:send', {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + tokenFCM,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        message: {
                            token: vToken,
                            data: { vNotificacion: vNotificacion }
                        }
                    })
                });

                const dataNtf = await response.json();
                console.log('Notificación enviada:', dataNtf);
            } catch (error) {
                console.error('Error al enviar la notificación:', error.message);
            }
        }
    };

    return {
        crearObjAction,
        guardarNotificacion,
        sendPushNotificationRealTime
    };
};
